import { render } from "./MenuContentItemValueSelect.vue?vue&type=template&id=feb930f4"
import script from "./MenuContentItemValueSelect.vue?vue&type=script&lang=js"
export * from "./MenuContentItemValueSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__